import { get, post } from './serve'

const getInit = get('/activity/api.php?m=front&subm=lottery&action=detail')
const getPrizeList = get('/activity/api.php?m=front&subm=lottery&action=prizelist')
const getDrawnum = get('/activity/api.php?m=front&subm=lottery&action=drawnum')
const getDrawPrize = get('/activity/api.php?m=front&subm=lottery&action=drawprize')
const postRegister = post('/activity/api.php?m=front&subm=lottery&action=register')
const getShareSuccess = get('/activity/api.php?m=front&subm=lottery&action=sharesuccess')

const getUdcData = get('/activity/api.php?m=public&subm=actstatistics')

export {
  getInit,
  getShareSuccess,
  postRegister,
  getPrizeList,
  getDrawnum,
  getDrawPrize,
  getUdcData
}



// WEBPACK FOOTER //
// ./src/api/index.js